export const SET_PHONE_LANGUAGE = 'SET_PHONE_LANGUAGE';

export type EnvState = {
  osType: 'android' | 'iOS' | 'none';
  osVersion: string;
  appVersion: string;
  deviceId: string;
  theme: 'polarisLight' | 'polarisDark' | 'otcLight' | 'otcDark';
  app: 'libre1' | 'llu5' | 'clm';
  deviceManufacturer: string;
  deviceModel: string;
  country: string;
  phoneLanguage: string;
};

type SetPhoneLanguageAction = {
  type: typeof SET_PHONE_LANGUAGE;
  phoneLanguage: string;
};

export type EnvActions = SetPhoneLanguageAction;
